export default "__VITE_ASSET__DssR4nb9__"